import actionCreator from '../common/actionObjectCreator';

import submitData from '../common/postData';

export const actionDescriptor = "account/";

const createAction = actionCreator(actionDescriptor);

const LOAD_ORDERS = createAction("LOAD_ORDERS");
const LOAD_PORTFOLIOS = createAction("LOAD_PORTFOLIOS");
const RESET_PASSWORD = createAction("RESET_PASSWORD");
const LOAD_PW_RESET = createAction("LOAD_PW_RESET");
const SUBMIT_PW_RESET = createAction("SUBMIT_PW_RESET");
const SUBMIT_USER_PW_RESET = createAction("SUBMIT_USER_PW_RESET");
const DELETE_USER_PORTFOLIO = createAction("DELETE_USER_PORTFOLIO");

export function loadOrders() {
    return dispatch => {
        submitData('Account/Orders', {}, LOAD_ORDERS, dispatch, true, {}, 'POST', true, 1000);
    }
}

export function loadPortfolios(name) {
    return dispatch => {
        submitData('Account/UserPortfolios', { name }, LOAD_PORTFOLIOS, dispatch, true, { name }, 'POST', true, 1000);
    }
}

export function resetPassword({ email, onError }) {
    return dispatch => {
        submitData('Account/RequestPasswordReset', { email }, RESET_PASSWORD, dispatch, true, {}, 'POST', true, 1000, null, onError);
    }
}

export function loadPasswordReset({ id, onError }) {
    console.log()
    return dispatch => {
        submitData('Account/LoadPasswordReset', { id }, LOAD_PW_RESET, dispatch, true, {}, 'POST', true, 1000, null, onError);
    }
}

export function submitPasswordReset({ id, password, onError }) {
    console.log()
    return dispatch => {
        submitData('Account/SetPasswordReset', { id, password }, SUBMIT_PW_RESET, dispatch, true, {}, 'POST', true, 1000, null, onError);
    }
}

export function submitUserPasswordReset({ password, newPassword, onError }) {
    console.log()
    return dispatch => {
        submitData('Account/SetUserPasswordReset', { password, newPassword }, SUBMIT_USER_PW_RESET, dispatch, true, {}, 'POST', true, 1000, null, onError);
    }
}

export function deletePortfolio(portfolioId, orderId, callback) {
    return dispatch => {
        submitData('Account/DeleteUserPortfolio', { portfolioId }, DELETE_USER_PORTFOLIO, dispatch, true, { portfolioId, orderId }, 'POST', true, 1000, () => {
            callback && callback();
        });
    }
}


const defaultState = {
    account: {

    },
    orders: [

    ],
    portfolios: [

    ]
};

const reducer = (state = defaultState, action) => {
    var ret;

    switch (action.type) {
        case LOAD_ORDERS.pending:
            ret = Object.assign({}, state, { loading: true, orders: [], error: null });
            return ret;
        case LOAD_ORDERS.fulfilled:
            ret = Object.assign({}, state, { loading: false, orders: action.payload });

            return ret;
        case LOAD_ORDERS.rejected:
            ret = Object.assign({}, state, { loading: false, error: action.payload });
            return ret;
        case LOAD_PORTFOLIOS.pending:
            ret = Object.assign({}, state, { loading: true, portfolios: [], error: null });
            return ret;
        case LOAD_PORTFOLIOS.fulfilled:
            ret = Object.assign({}, state, { loading: false, portfolios: action.payload });
            return ret;
        case LOAD_PORTFOLIOS.rejected:
            ret = Object.assign({}, state, { loading: false, error: action.payload });
            return ret;
        case RESET_PASSWORD.pending:
            ret = Object.assign({}, state, { passwordResetting: true, passwordResettingSuccess: false, error: null });
            return ret;
        case RESET_PASSWORD.fulfilled:
            ret = Object.assign({}, state, { passwordResetting: false, passwordResettingSuccess: true });
            return ret;
        case RESET_PASSWORD.rejected:
            ret = Object.assign({}, state, { passwordResetting: false, error: action.payload });
            return ret;
        case LOAD_PW_RESET.pending:
            ret = Object.assign({}, state, { loadingReset: true, passwordResettingSuccess: false, error: null, resetEmail: null });
            return ret;
        case LOAD_PW_RESET.fulfilled:
            ret = Object.assign({}, state, { loadingReset: false, passwordResettingSuccess: true, resetEmail: action.payload.email });
            return ret;
        case LOAD_PW_RESET.rejected:
            ret = Object.assign({}, state, { loadingReset: false, error: action.payload });
            return ret;
        case SUBMIT_PW_RESET.pending:
        case SUBMIT_USER_PW_RESET.pending:
            ret = Object.assign({}, state, { passwordResetting: true, passwordResettingSuccess: false, error: null });
            return ret;
        case SUBMIT_PW_RESET.fulfilled:
        case SUBMIT_USER_PW_RESET.fulfilled:
            ret = Object.assign({}, state, { passwordResetting: false, passwordResettingSuccess: true });
            return ret;
        case SUBMIT_PW_RESET.rejected:
        case SUBMIT_USER_PW_RESET.rejected:
            ret = Object.assign({}, state, { passwordResetting: false, error: action.payload });
            return ret;
        case DELETE_USER_PORTFOLIO.pending:
            ret = Object.assign({}, state, { ...state, portfolioDeleting: true });
            return ret;
        case DELETE_USER_PORTFOLIO.fulfilled:
            ret = Object.assign({}, state, { ...state, portfolioDeleting: false });

            if (action.orderId) {

                var order = ret.orders.orders.find(e => e.id === action.orderId);

                var portfolio = order.portfolios.find(e => e.id === action.portfolioId);

                portfolio.isDeleted = true;

            }
            else if (ret.portfolios && ret.portfolios.portfolios) {
                var found = ret.portfolios.portfolios.find(e => e.instances.find(f => f.id === action.portfolioId));

                if (found) {
                    var found2 = found.instances.find(f => f.id === action.portfolioId);
                    found.instances.splice(found.instances.indexOf(found2), 1);

                    if (found.instances.length === 0) {
                        ret.portfolios.portfolios.splice(ret.portfolios.portfolios.indexOf(found), 1);
                    }
                }
            }

            return ret;
        case DELETE_USER_PORTFOLIO.rejected:
            ret = Object.assign({}, state, { ...state, portfolioDeleting: false, error: action.payload });
            return ret;
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/account/account.duck.js